export function setReady(ready) {
    return {
        type: "SYSTEM_SET_READY",
        ready
    }
}

export default {
    setReady
}